










































import Vue, { PropType } from 'vue'
import { chipClasses } from '@/utils/chipClasses.constant'
import mnt from 'moment'
import { HistoryItem, GetTopUpDTO } from '@/utils/interfaces/topup.interface'
import { formatDate } from '@/utils/functions'
import { Remittance } from '@/utils/interfaces/remittance.interface'

export default Vue.extend({
  props: {
    item: Object as PropType<GetTopUpDTO | Remittance>,
  },
  computed: {
    historyObject() {
      let history = [] as {
        date: string
        text: string
        status: { icon: string; color: string }
      }[]
      mnt.locale(this.$store.getters.lang)
      const excludeFields = ['status', 'date']
      if (this.item.history) {
        history = this.item.history
          .map((item: HistoryItem) => ({
            date: formatDate(item.date),
            text: item.status,
            status: chipClasses[item.status] || {
              color: 'brown',
              icon: 'mdi-help',
            },
            details: Object.entries(item)
              .filter(([key]) => !excludeFields.includes(key))
              .map(([key, value]) => ({
                text: key,
                value: value,
              })),
          }))
          .reverse()
      }
      return history
    },
  },
})
